import React, { useState, useEffect } from 'react'
import { castArray, isArray } from 'lodash-es'
import clsx from 'clsx'
import { Input, Button, Modal } from '@ow/comps'
import { useTheme } from '@ow/theme'
import { showFiledValue } from '@ow/ditto-core'

const Render = function ({
  opts = {},
  widgets = {},
  data,
  value,
  onChange,
  detailData,
}) {
  const { themeClass } = useTheme()
  const { filters, layouts, findDataSlug } = opts || {} // layouts 说明是布局样式即新增关联表数据而不是从关联表选数据
  const [showTable, setShowTable] = useState(false)
  const { tbId, inline, title, refTbdefs = {}, multiple, slug } = opts
  const { fields, tbId: refTbId } = refTbdefs
  const [selectUser, setSelectUsers] = useState([])
  // ref表格筛选id
  const [refSelectedIds, setRefSelectedIds] = useState(null)
  const [finnalRefSelectedIds, setFinnalRefSelectedIds] = useState(null)

  // 处理编辑默认回显
  useEffect(() => {
    if (value && detailData && detailData.length > 0) {
      let _data = [
        detailData.find((x) => x[slug] && x[slug].objectId === value)?.[slug],
      ]
      // 处理多选情况
      if (multiple) {
        if (isArray(value)) {
          _data = value.map(
            (x) =>
              detailData.find((y) => y[slug] && y[slug].objectId === x)?.[slug]
          )
        }
      }
      if (_data.length > 0 && _data[0]) {
        setSelectUsers(_data)
      }
    }
  }, [detailData, value])
  const Widget = widgets.ref
  if (!Widget) {
    return null
  }
  const onReset = () => {
    setSelectUsers([])
    onChange(multiple ? [] : null)
  }

  return (
    <div className="w-full h-full flex flex-row items-center">
      {!inline && !layouts ? (
        <>
          <Input
            name={opts.slug}
            autoComplete="off"
            className="flex-1 w-full"
            style={{
              paddingLeft: '0.75rem',
              paddingRight: '0.75rem',
              fontSize: '0.8125rem',
            }}
            placeholder={opts.hint || '请选择'}
            readonly
            value={(selectUser || value || [])
              .map((_data) => {
                console.log(
                  showFiledValue(_data, fields, findDataSlug),
                  '_data_data_data'
                )
                return showFiledValue(_data, fields, findDataSlug)
              })
              .join('、')}
            onClick={() => {
              setShowTable(true)
            }}
            onChange={onReset}
          />
          <Modal
            title={title}
            nested
            size="lg"
            showCloseButton
            closeOnDocumentClick={false}
            contentStyle={{ height: '35rem' }}
            open={showTable}
            onClose={() => setShowTable(false)}
          >
            <div
              className={clsx(
                themeClass,
                'w-full h-full flex flex-col justify-between'
              )}
            >
              <Widget
                tbId={tbId || refTbId}
                selectedObjectIds={value ? castArray(value) : []}
                filters={filters}
                multiple={multiple}
                setRefSelectedIds={setRefSelectedIds}
                inline={inline}
                finnalRefSelectedIds={finnalRefSelectedIds}
                onChange={(e) => {
                  if (e) {
                    setSelectUsers(multiple ? e : [e])
                    onChange(multiple ? e.map((v) => v.objectId) : e.objectId)
                  } else {
                    setSelectUsers([])
                    onChange(null)
                  }
                }}
              />

              <div className="w-full flex gap-2 justify-end mt-5">
                <Button
                  type="secondary"
                  opacityType="sm"
                  onClick={() => {
                    setShowTable(false)
                    onChange()
                  }}
                >
                  取消
                </Button>
                <Button
                  type="primary"
                  onClick={() => {
                    setShowTable(false)
                    if (refSelectedIds) {
                      setSelectUsers(
                        multiple ? refSelectedIds : [refSelectedIds]
                      )
                      onChange(
                        multiple
                          ? refSelectedIds.map((v) => v.objectId)
                          : refSelectedIds.objectId
                      )
                    } else {
                      setSelectUsers([])
                      onChange(null)
                    }
                    setFinnalRefSelectedIds(refSelectedIds)
                  }}
                >
                  确定
                </Button>
              </div>
            </div>
          </Modal>
        </>
      ) : (
        <Widget
          tbId={tbId || refTbId}
          filters={filters}
          layouts={layouts}
          value={value}
          opts={opts}
          data={data}
          selectedObjectIds={value ? castArray(value) : []}
          multiple={multiple}
          onChange={(e) => {
            if (layouts) {
              onChange(e)
            } else {
              setSelectUsers(multiple ? e : [e])
              onChange(multiple ? e.map((v) => v.objectId) : e.objectId)
            }
          }}
          inline={inline}
        />
      )}
    </div>
  )
}

export default Render
